module.exports = __webpack_public_path__ + "static/media/modal1Bg.3df7b51b.png";